import IntranetLayout from "@/components/IntranetLayout";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Ship, Anchor, CloudSun, ClipboardCheck } from "lucide-react";
import { EmployeeFleetContent } from "./EmployeeFleet";
import { EmployeeVoyageOperationsContent } from "./EmployeeVoyageOperations";
import { WeatherRoutingContent } from "./WeatherRouting";
import { PreArrivalChecklistContent } from "./PreArrivalChecklist";

const VoyageManagement = () => {
  return (
    <IntranetLayout>
      <div className="mb-4">
        <h1 className="text-2xl font-bold text-[#00283C] font-display">Voyage Management</h1>
        <p className="text-sm text-muted-foreground">
          Fleet & Vessels, Voyage Operations, Weather Routing and Pre-Arrival Checklist — unified voyage planning workspace.
        </p>
      </div>

      <Tabs defaultValue="fleet" className="w-full">
        <TabsList className="bg-[#F4F7FA] mb-4 flex-wrap h-auto">
          <TabsTrigger value="fleet"><Ship className="w-4 h-4 mr-1" /> Fleet & Vessels</TabsTrigger>
          <TabsTrigger value="voyages"><Anchor className="w-4 h-4 mr-1" /> Voyage Operations</TabsTrigger>
          <TabsTrigger value="weather"><CloudSun className="w-4 h-4 mr-1" /> Weather Routing</TabsTrigger>
          <TabsTrigger value="prearrival"><ClipboardCheck className="w-4 h-4 mr-1" /> Pre-Arrival Checklist</TabsTrigger>
        </TabsList>

        <TabsContent value="fleet" className="mt-0">
          <EmployeeFleetContent />
        </TabsContent>

        <TabsContent value="voyages" className="mt-0">
          <EmployeeVoyageOperationsContent />
        </TabsContent>

        <TabsContent value="weather" className="mt-0">
          <WeatherRoutingContent />
        </TabsContent>

        <TabsContent value="prearrival" className="mt-0">
          <PreArrivalChecklistContent />
        </TabsContent>
      </Tabs>
    </IntranetLayout>
  );
};

export default VoyageManagement;
